module.exports = __webpack_public_path__ + "static/media/sameer_kavthekar.4a97208d.jpg";